export type VehicleOwnership = {
  vehicle: {
    vin: string
  }
}

export const VehicleOwnershipSource = {
  WEB_SERVICE: 'web_service',
} as const

export type VehicleOwnershipSource =
  (typeof VehicleOwnershipSource)[keyof typeof VehicleOwnershipSource]

export type IdentifyNonCinchOwnershipRequest = {
  source: VehicleOwnershipSource
  vin: string
  vrm: string
  make: string
  model: string
  emailAddress: string
  variant?: string
  colour?: string
  registrationDate?: string
  mot?: {
    status?: string
    expiryDate?: string
  }
  tax?: {
    status?: string
    dueDate?: string
  }
  service?: {
    serviceDueDate?: string
  }
}
